import { DEFAULT_SEGMENT, AUTH_PATHS } from '#client/build-env';

export const website = (environment) => environment !== 'production'
  ? 'https://dev.zenbusiness.com'
  : 'https://www.zenbusiness.com';
export const shopLLC = (environment) => `${website(environment)}/shop/llc/business-state`;

// Exporting these as constants means linting can validate their existence.
export const callback = AUTH_PATHS?.callbackUri;
export const login = AUTH_PATHS?.loginUri;
export const logout = AUTH_PATHS?.logoutUri;
export const landing = DEFAULT_SEGMENT;
export const test = `${DEFAULT_SEGMENT}/test`;

// New thread-based routes
export const threadCreator = `${DEFAULT_SEGMENT}/company/:businessEntityUuid`;
export const thread = `${DEFAULT_SEGMENT}/thread/:threadUuid`;

// Visitor routes
export const businessIdea = `${DEFAULT_SEGMENT}/visitor/business-idea`;
export const businessName = `${DEFAULT_SEGMENT}/visitor/business-name`;
export const visitorThreadCreator = `${DEFAULT_SEGMENT}/visitor`;
export const visitorThread = `${DEFAULT_SEGMENT}/visitor/thread/:threadUuid`;

// Universal chat entry (production)
export const chatEntry = `${DEFAULT_SEGMENT}/chat`;
